var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "widgetContainer", attrs: { id: "inventory-list-widget" } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "loading-wrapper",
        },
        [_c("loading", { attrs: { loading: _vm.loading } })],
        1
      ),
      _vm._v(" "),
      !_vm.loading
        ? _c("inventory-list-with-date-picker", {
            ref: "inventoryListWithDatePicker",
            attrs: {
              "venue-id": _vm.venueId,
              theme: _vm.theme,
              shouldLockDate: _vm.shouldLockDate,
              "bg-color": _vm.bgColor,
              "button-bg-color": _vm.buttonBgColor,
              "button-text-color": _vm.buttonTextColor,
              "button-text": _vm.buttonText,
              "event-id": _vm.eventId,
              "inventory-type": _vm.inventoryType,
              disableInlineCheckout: _vm.disableInlineCheckout,
              "checkout-url": _vm.checkoutUrl,
            },
            on: {
              updated: _vm.onUpdated,
              datePickerOpened: _vm.onDatepickerOpened,
              inventorySelected: _vm.onInventorySelected,
              scrollTop: _vm.onScrollTop,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{"loaders":{"css":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"postcss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"less":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"less-loader","options":{"sourceMap":true}}],"sass":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"indentedSyntax":true,"sourceMap":true}}],"scss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"sourceMap":true}}],"stylus":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}],"styl":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}]}}!./src/pages/Widgets/InventoryList/template.html?vue&type=template&id=49076cae&
// module id = 1102
// module chunks = 0